import SearchOffRounded from '@mui/icons-material/SearchOffRounded';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Card } from '../Card';

interface Props {
    title?: string;
    description?: string;
}

const iconStyles = {
    fontSize: 100,
    color: 'grey.60',
    marginY: 2,
};

export const NoResultsFound = ({
    title = 'No items found',
    description = 'Try adjusting your search to find what you’re looking for.',
}: Props) => (
    <Box display="flex" alignItems="center" justifyContent="center" height="100%">
        <Card sx={{ width: '100%' }}>
            <Stack alignItems="center" justifyContent="center" height="100%" gap={2} py={3}>
                <SearchOffRounded sx={iconStyles} />
                <Typography variant="h4" textAlign="center">
                    {title}
                </Typography>
                <Typography textAlign="center">{description}</Typography>
            </Stack>
        </Card>
    </Box>
);
